import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useUser from 'src/hook/data/useUser';
import { useWords } from 'src/hook/data/useWords';
import { useAudio } from 'src/hook/global/useAudio';
import usePopUp from 'src/hook/modal/usePopUp';
import { AnswerType } from 'src/model/enum/enums';
import { Word } from 'src/model/Word';
import { GetSoundUrl, SenseImageLocation } from 'src/utils/URLUtils';
import styles from './DefinitionItem.module.scss';
interface DefinitionItemProps {
    choice: { isCorrect: boolean, text: string, wordId: number };
    index: number;
    onAnswer: (isCorrect: boolean) => void;
    correctWord: Word;
}

const DefinitionItem = ({ choice, index, onAnswer, correctWord }: DefinitionItemProps) => {
    const { t } = useTranslation();
    const [isClicked, setIsClicked] = useState(false);
    const letter = String.fromCharCode(97 + index).toUpperCase();
    const { isWordUpUser, isProUser } = useUser();
    const { getWordById } = useWords();
    const word = getWordById(choice.wordId);
    const { showProPopUp } = usePopUp();
    const showProImage = !isProUser();
    const { playAudio } = useAudio();

    const handleClick = () => {
        playAudio(GetSoundUrl(choice.isCorrect ? AnswerType.CorrectAnswer : AnswerType.IncorrectAnswer));
        setIsClicked(true);
        setTimeout(() => {
            onAnswer(choice.isCorrect);
        }, 200);
        setTimeout(() => {
            setIsClicked(false);
        }, 400);
    };

    const className = `${styles.definitionItem} ${isClicked ? styles.clicked : ''} ${isClicked ? (choice.isCorrect ? styles.correct : styles.incorrect) : ''}`;

    return (
        <div className={className} onClick={handleClick}>
            <div className={styles.imageContainer}>
                <img src={SenseImageLocation(word?.PrimarySenseId!, showProImage)} alt={t("DefinitionItem")} />
                {showProImage && (
                    <span
                        className={styles.showImageButton}
                        onClick={(e) => {
                            e.stopPropagation();
                            showProPopUp('Word photos & videos',
                                'Over 500,000 clips to bring every word to life, because your memory is visual.');
                        }}
                    >
                        {t('Show Image')}
                    </span>
                )}
            </div>
            <span className={styles.letter}>{letter}</span>
            <p>{choice.text}{choice.isCorrect && isWordUpUser() ? '..' : ''}</p>
        </div>
    );
};

export default DefinitionItem;
